import "./Ripple.scss";

export function Ripple(props) {
    return (
        <div className="lds-ripple"><div></div><div></div></div>
    )
}